/**
 * Group key of the favourite cars; shown as the last group in group lists
 * @type {string}
 */
export const FAVOURITES = 'favourites'

/**
 * Name of the favourites group
 * @type {string}
 */
export const FAVOURITES_LABEL = 'Favourites'

/**
 * Check whether a car is a favourite
 * @param {number|string} car start number
 * @param {Array<number>} favourites favourite start numbers
 * @returns {boolean} whether the car is a favourite
 */
export const isFavourite = ( car, favourites = [] ) => favourites.includes( parseInt( car ) )

/**
 * Add a car to the favourites, kept in number order
 * @param {Array<number>} favourites favourite start numbers
 * @param {number|string} car start number
 * @returns {Array<number>} new favourites
 */
export const addFavourite = ( favourites, car ) =>
{
  const number = parseInt( car )
  if ( !number || favourites.includes( number ) ) return favourites
  return [ ...favourites, number ].sort( ( a, b ) => a - b )
}

/**
 * Remove a car from the favourites
 * @param {Array<number>} favourites favourite start numbers
 * @param {number|string} car start number
 * @returns {Array<number>} new favourites
 */
export const removeFavourite = ( favourites, car ) => favourites.filter( favourite => favourite !== parseInt( car ) )

/**
 * Check whether a car belongs to a group; the favourites group holds the favourite cars
 * @param {number|string} car start number
 * @param {number|string} cat group of the car
 * @param {number|string} group group to check
 * @param {Array<number>} favourites favourite start numbers
 * @returns {boolean} whether the car is in the group
 */
export const isInGroup = ( car, cat, group, favourites = [] ) =>
  group === FAVOURITES ? isFavourite( car, favourites ) : String( cat ) === String( group )

/**
 * Turn typed text into a start number of at most 4 digits
 * @param {string} value typed text
 * @returns {string} start number, empty without digits
 */
export const toCarNumber = ( value ) =>
{
  const digits = String( value ).match( /\d+/g )
  return digits ? digits.join( '' ).substring( 0, 4 ) : ''
}
